<template>
    <form-row title="Detention Pond" :label_align_top="true" class="pt-0">
        <div class="w-full flex flex-col">
            <input-radio-boolean
                name="has_detention_pond"
                v-model="has_detention_pond"
                true="Yes"
                false="No"
                class="pt-2"
                :read_only="read_only"
            />

            <div v-if="has_detention_pond" class="pt-6 pb-2">
                <input-text
                    label="Where is it located now?"
                    class="w-full"
                    name="utilities_detention_pond"
                    :value="commercial.utilities_detention_pond"
                    :read_only="read_only"
                />

                <buyer-seller-split
                    label="Who is Responsible for Construction Costs?"
                    class="mt-5"
                    field="utilities_detention_pond_who_responsible"
                    :value="commercial.utilities_detention_pond_who_responsible"
                    :read_only="read_only"
                />
            </div>
        </div>
    </form-row>
</template>

<script>
import BuyerSellerSplit from '../buyer-seller-split.vue';
import MoneyFunctions from '../../../mixins/money-functions.js';

export default {
    mixins: [
        MoneyFunctions,
    ],

    components: {
        BuyerSellerSplit,
    },

    props: {
        read_only: { default: false },
        commercial: {},
    },

    data() {
        return {
            has_detention_pond: this.commercial.has_detention_pond,
        }
    },
}
</script>
